var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0",attrs:{"id":"background"}},[_c('v-img',{staticClass:"ma-0 d-flex justify-center align-center",attrs:{"src":"/images/Ellipse7.svg","id":"background","maxWidth":_vm.maxWidthBackground}},[_c('v-img',{staticClass:"ma-0",attrs:{"src":`/images/${_vm.image}.svg`,"id":"image","maxWidth":_vm.maxWidthImage}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }